(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[303],{

/***/ 1196:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/courses/python-beginner",
      function () {
        return __webpack_require__(6233);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 5002:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
const data = {
    links: {
        freePythonLectureRegistration: "https://forms.gle/BZyWuCnFAUvKbDot5",
        generalRegistrationForm: "https://formfaca.de/sm/QwkYhS7Wm"
    },
    courseTopics: [
        {
            id: "pb",
            name: "Python pradedantiesiems",
            description: "Course for someone",
            price: 400,
            hours: 40
        }
    ],
    courses: [
        {
            isPopular: true,
            id: "p-b",
            name: "Python pradedantiesiems",
            tags: [
                "python",
                "data-analysis",
                "beginner"
            ],
            type: "Dieninis",
            days: "PATKPxx",
            groupSize: [
                8,
                16
            ],
            intensity: 40,
            price: 330,
            hours: 40,
            startDate: "2022-11-21",
            description: "Python yra populiariausia pasaulyje programavimo kalba. Python kodas yra lengvai skaitomas, o taikymo sričių - begalė, įskaitant tinklalapių kūrimą, mašininį mokymąsį, automatizavimą ir t.t. Šis kursas puikiai tinka norintiems įgauti Python programavimo pagrindus ir pasirinkti tolimesnę kryptį.",
            // descriptionExtra:
            //   "Šis kursas yra paremtas partnerių, pagal jį paruošta 500 studentų Vokietijoje.",
            link: "python-beginner",
            active: true,
            // https://schema.org/CourseInstance
            courseInstances: [
                // {
                //   courseMode: "online",
                //   startDate: "2022-11-28",
                //   endDate: "2022-12-02",
                //   isAccessibleForFree: false,
                //   courseWorkload: "40 kontaktinių valandų",
                //   instructor: { "@type": "Person", name: "Aidis Stukas" },
                //   eventAttendanceMode: "online",
                //   organizer: { "@type": "Organization", name: "Pirmas kodas" },
                //   offers: {
                //     "@type": "Offer",
                //     availability: "https://schema.org/InStock",
                //     price: 330,
                //     priceCurrency: "EUR",
                //     // url: "http://www.ticketfly.com/purchase/309433",
                //   },
                //   extraType: "dieninė",
                //   extraTypeEmoji: "🏙️",
                //   extraDayTime: "DD, 09:00-17:00 su pertrauka",
                //   // Todo later
                //   // eventSchedule: {},
                // },
                // {
                //   courseMode: "online",
                //   startDate: "2023-01-23",
                //   endDate: "2023-02-17",
                //   isAccessibleForFree: false,
                //   courseWorkload: "40 kontaktinių valandų",
                //   instructor: { "@type": "Person", name: "Aidis Stukas" },
                //   eventAttendanceMode: "online",
                //   organizer: { "@type": "Organization", name: "Pirmas kodas" },
                //   offers: {
                //     "@type": "Offer",
                //     availability: "https://schema.org/InStock",
                //     price: 330,
                //     priceCurrency: "EUR",
                //     // url: "http://www.ticketfly.com/purchase/309433",
                //   },
                //   extraType: "vakarinė",
                //   extraTypeEmoji: "🌆",
                //   extraDayTime: "DD, 18:00-20:00",
                //   // Todo later
                //   // eventSchedule: {},
                //   order: 2,
                // },
                // {
                //   courseMode: "online",
                //   startDate: "2023-01-28",
                //   endDate: "2022-02-19",
                //   isAccessibleForFree: false,
                //   courseWorkload: "40 kontaktinių valandų",
                //   instructor: { "@type": "Person", name: "Aidis Stukas" },
                //   eventAttendanceMode: "online",
                //   organizer: { "@type": "Organization", name: "Pirmas kodas" },
                //   offers: {
                //     "@type": "Offer",
                //     availability: "https://schema.org/InStock",
                //     price: 330,
                //     priceCurrency: "EUR",
                //     // url: "http://www.ticketfly.com/purchase/309433",
                //   },
                //   extraType: "savaitgalinė",
                //   extraTypeEmoji: "☀️",
                //   extraDayTime: "Šeštadieniais, 10:00-13:00",
                //   // Todo later
                //   // eventSchedule: {},
                //   order: 2,
                // },
                {
                    courseMode: "online",
                    startDate: "2023-03-27",
                    endDate: "2023-04-14",
                    isAccessibleForFree: false,
                    courseWorkload: "40 kontaktinių valandų",
                    instructor: {
                        "@type": "Person",
                        name: "Aidis Stukas"
                    },
                    eventAttendanceMode: "online",
                    organizer: {
                        "@type": "Organization",
                        name: "Pirmas kodas"
                    },
                    offers: {
                        "@type": "Offer",
                        availability: "https://schema.org/InStock",
                        price: 600,
                        priceCurrency: "EUR"
                    },
                    extraType: "dieninė",
                    extraTypeEmoji: "\uD83C\uDFD9️",
                    extraDayTime: "10:00-12:00 darbo dienomis",
                    // Todo later
                    // eventSchedule: {},
                    order: 1
                }
            ],
            position: 1
        },
        {
            id: "p-da",
            name: "Duomenų analizė su Python",
            tags: [
                "python",
                "data-analysis",
                "pandas",
                "machine-learning"
            ],
            type: "Vakarinis",
            days: "PATKPxx",
            intensity: 40,
            price: 800,
            hours: 80,
            startDate: "2022-10-02",
            endDate: "2022-10-20",
            description: "Python programavimo kalba yra lyderė duomenų analizės srityje. Versle Python keičia ir papildo Excel bei kitas duomenų analizės priemonės. Baigę šį kursą galėsite mikliai naršyti, tvarkyti, analizuoti ir pristatyti duomenis su Python. Baigę šį kursą galėsite studijuoti mašininį mokymąsį.",
            link: "duomenu-analitika-su-python",
            active: true,
            position: 2
        },
        {
            id: "p-ds",
            name: "Duomenų mokslas ir mašininis mokymasis su Python",
            tags: [
                "python",
                "data-analysis",
                "pandas",
                "machine-learning"
            ],
            type: "Vakarinis",
            days: "PATKPxx",
            intensity: 40,
            price: 1200,
            hours: 80,
            startDate: "2022-10-02",
            endDate: "2022-10-20",
            description: "Tai žingsnis po duomenų analitikos. Susipažinsime su mašininiu mokymusi. Įvaldysime sklearn biblioteką. Susipažinsime su Xgboost, LightGbm bei neuroninių tinklų bibliotekomis (TensorFlow, Pytorch).",
            link: "masininis-mokymasis-su-python",
            active: true,
            position: 3
        },
        {
            id: "p-wd-be",
            name: "Backend Web dev su Python (Django arba FastAPI)",
            tags: [
                "python",
                "data-analysis",
                "pandas",
                "machine-learning"
            ],
            type: "Vakarinis",
            days: "PATKPxx",
            intensity: 40,
            price: 800,
            hours: 80,
            description: "Norite kurti web aplikacijas? Python turi bent keletą tam skirtų bibliotekų. Šis kursas labiausiai tinka tiems, kurie mėgsta dirbi su duomenimis ir neturi noro gilintis į dizainą ir UX/UI klausimus. Baigę šį kursą galėsite kuri web aplikacijų backend dalį.",
            link: "tinklalapiu-kurimas-su-python",
            active: true,
            position: 4
        },
        {
            id: "p-wd-fs",
            name: "Full stack Web dev su Python ir Javascript (React, Tailwind)",
            tags: [
                "python",
                "data-analysis",
                "pandas",
                "machine-learning"
            ],
            type: "Vakarinis",
            days: "PATKPxx",
            intensity: 40,
            price: 1500,
            hours: 120,
            description: "Full-stackeris žmogus, kuris dažniausiai reikalingas mažoms ir/arba judrioms(agile) kompanijoms. Esant poreikiui galėsite sukurti visą aplikaciją arba galėsite specializuotis į viena iš sričių bet tuo pačiu suprast ką daro kolegos 'kitame gale'.",
            link: "tinklalapiu-kurimas-su-python-ir-react",
            active: true,
            position: 5
        },
        {
            id: "p-ws",
            name: "Web scraping su Python",
            tags: [
                "python",
                "data-analysis",
                "pandas",
                "machine-learning"
            ],
            type: "Vakarinis",
            days: "PATKPxx",
            intensity: 40,
            price: 400,
            hours: 40,
            description: "Dažnas IT projektas priklauso nuo duomenų. Vieša paslaptis, kad didelė dalis kompanijų duomenis tiesiog renka iš interneto. Tai sena praktika, bet besikeičianti kiekvienais metais. Išmoksime įvairių scraping technikų. Baigę kursą galėsite sukurti sprendimą kuris nuolat tvarkingai ir patikimai surenka duomenis iš vieno ar net kelių šaltinių.",
            link: "web-scraping-su-python",
            active: true,
            position: 6
        }
    ]
};
/* harmony default export */ __webpack_exports__["Z"] = (data);


/***/ }),

/***/ 4594:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "OR": function() { return /* binding */ Companies; },
  "SH": function() { return /* binding */ PythonPrerequisite; }
});

// UNUSED EXPORTS: BestPrice, UnderConstruction

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
;// CONCATENATED MODULE: ./node_modules/@heroicons/react/24/outline/esm/CurrencyEuroIcon.js


function CurrencyEuroIcon_CurrencyEuroIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/react.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M14.25 7.756a4.5 4.5 0 100 8.488M7.5 10.5h5.25m-5.25 3h5.25M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
  }));
}

const ForwardRef = react.forwardRef(CurrencyEuroIcon_CurrencyEuroIcon);
/* harmony default export */ var esm_CurrencyEuroIcon = (ForwardRef);
;// CONCATENATED MODULE: ./node_modules/@heroicons/react/24/outline/esm/ExclamationTriangleIcon.js


function ExclamationTriangleIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/react.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z"
  }));
}

const ExclamationTriangleIcon_ForwardRef = react.forwardRef(ExclamationTriangleIcon);
/* harmony default export */ var esm_ExclamationTriangleIcon = (ExclamationTriangleIcon_ForwardRef);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./components/info.jsx



const commonClassGreen = "gap-3 rounded-lg flex  bg-green-100 border border-l-4 border-green-500 text-green-700   px-4 py-1 dark:bg-gray-900 dark:text-green-500   dark:border-green-500";
const commonClassYellow = "gap-3 rounded-lg flex  bg-yellow-100 border border-l-4 border-yellow-500 text-yellow-700  px-4 py-1 dark:bg-stone-900 dark:text-yellow-200  dark:border-yellow-200";
const commonClassOrange = "gap-3 rounded-lg flex  bg-red-100 border border-l-4 border-red-500 text-red-700 2 px-4 py-1 dark:bg-gray-900 dark:text-red-400   dark:border-red-500";
const UnderConstruction = ()=>{
    return /*#__PURE__*/ _jsxs("div", {
        className: commonClassGreen,
        role: "alert",
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "basis-1/12",
                children: /*#__PURE__*/ _jsx(InformationCircleIcon, {
                    className: "v-12 h-12"
                })
            }),
            /*#__PURE__*/ _jsx("div", {
                children: "Šiuo metu vyksta atnaujinimo darbai"
            })
        ]
    });
};
const Companies = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: commonClassGreen + " flex flex-col",
        role: "alert",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                className: "text-2xl font-bold",
                children: [
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_CurrencyEuroIcon, {
                        className: "inline h-12"
                    }),
                    " Įmonėms"
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    "Ši programa gali būti pritaikyti Jūsų poreikiams.",
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: "/for-companies",
                        children: "Daugiau"
                    })
                ]
            })
        ]
    });
};
const BestPrice = ()=>{
    return /*#__PURE__*/ _jsxs("p", {
        className: commonClassYellow + " flex flex-col",
        role: "alert",
        id: "best-price",
        children: [
            /*#__PURE__*/ _jsxs("span", {
                className: "text-2xl font-bold",
                children: [
                    " ",
                    /*#__PURE__*/ _jsx(CurrencyEuroIcon, {
                        className: "inline h-12"
                    }),
                    " Geriausia kaina"
                ]
            }),
            /*#__PURE__*/ _jsxs("span", {
                children: [
                    " ",
                    "Radote panašią programą už mažesnę kainą? Pirmas kodas pasiruošęs mokymų kainą sumažinti iki Jūsų rastos!"
                ]
            })
        ]
    });
};
const PythonPrerequisite = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: commonClassOrange + " flex flex-col",
        role: "alert",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "text-2xl font-bold",
                children: [
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_ExclamationTriangleIcon, {
                        className: "inline h-12"
                    }),
                    "Reikalingos žinios"
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    " ",
                    "Šie mokymai rekomenduojami turintiems Python programavimo kalbos pagrindus. Juos galite įgyti pas mus.",
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: "/courses/python-beginner",
                        children: "Python pradedantiesiems"
                    })
                ]
            })
        ]
    });
};



/***/ }),

/***/ 2076:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Fp": function() { return /* binding */ courseDataToSchema; },
/* harmony export */   "VD": function() { return /* binding */ schemaElementFromSchema; },
/* harmony export */   "aV": function() { return /* binding */ orderByOrder; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4298);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_script__WEBPACK_IMPORTED_MODULE_1__);


const courseDataToSchema = (data, courseId)=>{
    const course = data.courses.filter((course)=>course.id == courseId)[0];
    const schema = ((param)=>{
        let { name , description , courseInstances  } = param;
        return {
            name,
            description,
            courseInstances
        };
    })(course);
    schema["@context"] = "https://schema.org";
    schema["@type"] = "Course";
    schema["provider"] = {
        "@type": "Organization",
        name: "Pirmas kodas",
        sameAs: "https://pirmaskodas.lt"
    };
    return schema;
};
const schemaElementFromSchema = (schema)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_script__WEBPACK_IMPORTED_MODULE_1___default()), {
        id: schema.name,
        type: "application/ld+json",
        dangerouslySetInnerHTML: {
            __html: JSON.stringify(schema)
        }
    });
function orderByOrder(a, b) {
    if (a.order < b.order) {
        return -1;
    }
    if (a.order > b.order) {
        return 1;
    }
    return 0;
}



/***/ }),

/***/ 6233:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ python_beginner; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/script.js
var script = __webpack_require__(4298);
var script_default = /*#__PURE__*/__webpack_require__.n(script);
// EXTERNAL MODULE: ./components/data.js
var data = __webpack_require__(5002);
;// CONCATENATED MODULE: ./components/disclosure.jsx



function MyDisclosure(param) {
    let { name , content  } = param;
    return /*#__PURE__*/ _jsxs(Disclosure, {
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "flex",
                children: [
                    /*#__PURE__*/ _jsx(Disclosure.Button, {
                        className: "inline",
                        children: name
                    }),
                    /*#__PURE__*/ _jsx(ChevronUpIcon, {
                        className: "inline h-10"
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(Disclosure.Panel, {
                children: content
            })
        ]
    });
}
/* harmony default export */ var disclosure = ((/* unused pure expression or super */ null && (MyDisclosure)));

// EXTERNAL MODULE: ./components/info.jsx + 2 modules
var info = __webpack_require__(4594);
// EXTERNAL MODULE: ./components/utils.jsx
var utils = __webpack_require__(2076);
;// CONCATENATED MODULE: ./pages/courses/python-beginner.jsx










// Kurso aprašymas
// Python programavimo kalba yra lyderė duomenų analizės srityje. Versle Python keičia ir .
// Python programavimo kalba
// Ko išmoksite
// Po mokymų
// - Galimi įgūdžiai
// - Rinktis tolimesnę specializaciją
// Mokymai įmonėms
// Individualūs mokymai
// Lektoriai
// D.U.K
const CourseInstance = (param)=>{
    let { instance , course  } = param;
    const onClick = ()=>{
        window.dataLayer.push({
            event: "courseInstanceClick",
            name: "".concat(course.name, "_").concat(instance.startDate)
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "pb-2 text-xl font-bold capitalize md:col-span-2 ",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        instance.extraTypeEmoji,
                        " ",
                        instance.extraType,
                        " ",
                        instance.startDate
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            "Kur: ",
                            instance.courseMode
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            "Trukmė: ",
                            instance.startDate,
                            " – ",
                            instance.endDate
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            "Laikas: ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "font-bold",
                                children: instance.extraDayTime
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            "Intensyvumas: ",
                            course.hours,
                            " val."
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            "Kaina: nuo ",
                            instance.offers.price,
                            " €"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            "Valandos kaina: nuo",
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                className: "font-bold text-yellow-700 dark:text-yellow-200",
                                children: [
                                    instance.offers.price / course.hours,
                                    " €/val."
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex justify-center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RegistrationButton, {
                            href: data/* default.links.generalRegistrationForm */.Z.links.generalRegistrationForm,
                            onClick: onClick
                        })
                    })
                ]
            })
        ]
    }, instance.startDate);
};
const RegistrationButton = (param)=>{
    let { href , onClick  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "p-5",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                href: href,
                target: "_blank",
                rel: "noopener noreferrer",
                className: " transition-border rounded-md bg-mustard p-2 font-bold uppercase transition-colors duration-1000 dark:bg-green-500 dark:text-black",
                onClick: onClick,
                children: "Registracija"
            })
        })
    });
};
const Course = ()=>{
    const course = data/* default.courses.filter */.Z.courses.filter((course)=>course.id == "p-b")[0];
    const schema = ((param)=>{
        let { name , description , courseInstances  } = param;
        return {
            name,
            description,
            courseInstances
        };
    })(course);
    schema["@context"] = "https://schema.org";
    schema["@type"] = "Course";
    schema["provider"] = {
        "@type": "Organization",
        name: "Pirmas kodas",
        sameAs: "https://pirmaskodas.lt"
    };
    const courseInstances = schema.courseInstances;
    const schemaElement = /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
        id: "schemaPython",
        type: "application/ld+json",
        dangerouslySetInnerHTML: {
            __html: JSON.stringify(schema)
        }
    });
    const sampleProjects = [
        [
            "Kryžiukai-nuliukai",
            "Vienas labiausiai žinomų žaidimų. Pabaigę mokymus sugebėsite parašyti kryžiukų-nuliukų žaidimą-programą!",
            "/xo.png",
            "dark:invert"
        ],
        [
            "Failų skirstytojas",
            "Funkcionalumas: nurodome programai failą arba direktoriją, programa suskirsto rastus failus pagal jų plėtinius (txt, pdf, xlsx) į atskiras direktorijas.",
            "/file-tree.webp",
            "dark:invert"
        ],
        [
            "Fotografijų tvarkytojas",
            "Funkcionalumas: nurodome direktorija, programa automatiškai pritaiko efektus, pakeičia šviesumą, kontrastą, apkarpo, prideda logotipą ir t.t.",
            "/image-edit.jpg",
            ""
        ],
        [
            "Užduočių (to do) programėlė",
            "Funkcionalumas: pridėk užduotį, ištrink užduotį, pažymėk kaip padarytą, pridėk terminą, parodyk šios >conos užduotis ir t.t.",
            "/todo.webp",
            "dark:invert"
        ],
        [
            "Prekių kainų rinkėjas",
            "Iš numatyto puslapio, automatiškai, surink reikalingas prekių pavadinimus, aprašymus. Programa, o informacija automatiškai sukrenta į txt arba Excel failą!",
            "/scraper.png",
            "dark:invert"
        ]
    ];
    const features = [
        // ["Akademinė veikla", "Python academy"],
        [
            "Stebėk paskaitą NEMOKAMAI",
            "Jei negalite išsirinkti mokymų, ateikite stebėti pasirinktą paskaitą NEMOKAMAI",
            "\uD83C\uDD93"
        ],
        [
            "Paskaitų įrašai",
            "Turėsite galimybę gauti paskaitų įrašus, jei praleidote paskaitą ar norite pasikartoti",
            "\uD83D\uDCF9"
        ],
        // [
        //   "Tikslas",
        //   "Individuali, personalizuota IT mokymų programa, kurios pagrindinis tikslas – žmogaus įdarbinimas tech sektoriuje",    "🤝"],
        [
            "Karjeros planavimas",
            "Po mokymų absolventams padedame pasirinkti tolimesnį kelią, pasiruošti CV, pasirengti pokalbiui su darbdaviu.",
            "\uD83E\uDD1D"
        ],
        [
            "Išduodamas sertifikatas",
            "Po mokymų įteikiamas oficialus, Pirmas kodas kursų išklausymo sertifikatas.",
            "\uD83C\uDF93"
        ],
        [
            "Nemokamas kurso kartojimas",
            "Galimybė metų bėgyje grįžti kartoti kurso NEMOKAMAI",
            "⏪"
        ]
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: "Python pradedantiesiems | Pirmas kodas"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: 'Mokymai "Python pradedantiesiems" skirti norintiems išmokti populiariausią pasaulyje programavimo kalbą. Python yra lengvai skaitoma ir labai plačiai naudojama.'
                    })
                ]
            }),
            schemaElement,
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "grid gap-2 lg:grid-cols-12",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("aside", {
                        className: "px-2 lg:col-span-3 ",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "my-background sticky top-14 mt-0",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                    children: "Navigacija"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                    className: "underline-none flex list-disc flex-col gap-2 pl-4",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: "#main",
                                                children: "Python pradedantiesiems"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: "#projects",
                                                children: "Baigiamųjų darbų pavyzdžiai"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: "#python-academy",
                                                children: "PythonAcademy.com"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: "#program",
                                                children: "Programa"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: "#features",
                                                children: "Savybės"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: "#trainer",
                                                children: "Dėstytojas"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: "#price",
                                                children: "Kainos"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: "#discounts",
                                                children: "Nuolaidų sistema"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: "#payment",
                                                children: "Apmokėjimo galimybės"
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
                        className: "prose max-w-none dark:prose-invert prose-h2:mt-0 prose-h2:pt-2 lg:col-span-6 ",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                id: "main",
                                className: "my-background",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                        className: "break-words",
                                        children: "Python pradedantiesiems"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                children: "Aprašymas"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                children: course.description
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                children: "Tikslinė auditorija"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                children: "Kursas sukurtas neturintiems programavimo patirties. Tereikia gebėti naudotis operacine sistema, kurti, kopijuoti, redaguoti failus, įsidiegti programinę įrangą. Lengviau bus tiems, kurie yra įgūdę MS Office paketo naudotojai arba yra susipažinę su HTML ar panašiomis technologijomis."
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                children: "Ką veikti pabaigus?"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                children: [
                                                    "Šiame kurse įgijote Python pagrindus. Jau galite skaityti Python kodą, parašyti nedidelę programą. Gali būti, kad pritaikysite Python darbovietėje arba namuose. Tačiau dar neturite tiek įgūdžių, kad galėtumėte būti pilnaverčiu programuotoju ar duomenų analitiku. Norintiems pasiekti kitą lygį kviečiame rinktis vieną iš tolimesnių kursų.",
                                                    " ",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                        href: "courses",
                                                        children: "Pirmas kodas kursai"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                id: "projects",
                                className: "my-background",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                        children: "Baigiamųjų darbų pavyzdžiai"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: "Keletas pavyzdžiu baigiamųjų projektų, kuriuos galėtų tikėtis padaryti šio kurso studentai"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: sampleProjects.map((param)=>{
                                            let [name, description, imagePath, additionalClass] = param;
                                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "grid items-center gap-3 p-3 md:grid-cols-6",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                        className: "md:col-span-6",
                                                        children: name
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: "md:col-span-4 ",
                                                        children: description
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "flex justify-center md:col-span-2",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                            className: "m-0 h-auto " + additionalClass,
                                                            src: imagePath,
                                                            width: 100,
                                                            height: 100,
                                                            alt: "work"
                                                        })
                                                    })
                                                ]
                                            }, name);
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                id: "python-academy",
                                className: "my-background break-words",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                        children: "Python-Academy.com"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                        className: "m-0",
                                        children: "Kaip užtikrinama kurso kokybė?"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                        children: [
                                            "Pirmas kodas yra sertifikuoti",
                                            " ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                href: "https://python-academy.com",
                                                children: "PythonAcademy.com"
                                            }),
                                            ". partneriai. PythonAcademy.com yra nuo 2006 metų Python mokymus veikianti kompanija. Pirmo kodo Python pradedantiesiems kursas yra parengtas būtent pagal PythonAcademy.com programą."
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex items-center",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "hidden dark:block ",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                    href: "https://www.python-academy.com/",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                        className: "h-auto w-full",
                                                        src: "/pya_logo_white.svg",
                                                        alt: "Python Academy",
                                                        width: 175 * 2,
                                                        height: 68 * 2
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "block dark:hidden",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                    href: "https://www.python-academy.com/",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                        className: "h-auto w-full",
                                                        src: "/pya_logo_rgb.svg",
                                                        alt: "Python Academy",
                                                        width: 175 * 2,
                                                        height: 68 * 2
                                                    })
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "max-h-max-1/2 flex flex-col gap-8 p-4",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "text-lg",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "p-3 text-center text-3xl",
                                                        children: "9000+"
                                                    }),
                                                    "studentų dalyvavo PythonAcademy.com kursuose"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "text-lg ",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "p-3 text-center text-3xl",
                                                        children: "816+"
                                                    }),
                                                    "mokymų grupių pravedė PythonAcademy.com",
                                                    " "
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "text-lg ",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "p-3 text-center text-3xl",
                                                        children: "2250+"
                                                    }),
                                                    " dienų mokymų pravedė PythonAcademy.com",
                                                    " "
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "text-left text-lg",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "p-3 text-center text-3xl",
                                                        children: "3300+"
                                                    }),
                                                    "studentų baigė mokymus pagal šią programą"
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                id: "program",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "my-background mt-10",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                            children: "Programa"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                    children: "Pagrindai ir duomenu strukturos"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: "Ivadas i JupyterLab"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: "Python sintaksė"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: "Statements and expressions"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: "Control flow"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: "Ciklai"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: "Duomenų tipų apžvalga"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: "Sąrašai ir tuplai"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: "Žodynai"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: "Setai"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                    children: "Procedūrinis ir objektinis programavimas"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                                    className: "simple",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: "Funkcijos"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: "Generatoriai ir iteratoriai"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: "Klasės"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: "Paveldėjimas"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: "Operator overloading"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: "Išimčių valdymas"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: "Input / output"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                    children: "Projektai"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: "nedidelis Python projektas"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: "Moduliai ir paketai"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: "Pavadinimai ir objektai"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: "Namespaces and scoping"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                    children: "Practical Applications and Libraries"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: "Teksto apdorojimas"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: "System functions"
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "my-background",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                        children: "Papildoma informacija apie programą"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                children: "Pratimai"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                children: "Visi dalyviai gali sekti žingsinius kompiuteryje. Kiekvieno skyriaus pabaigoje daromi pratimai. Tokiu būdu įsisavinime įgūdžius."
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                children: "Kurse naudojama programinė įranga"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                children: "Kurso dalyviams nereikės diegti papildomos programinės įrangos. T.y. į kompiuterį nereikės instaliuoti jokių programų. Tereikia naršyklės ir patikimo interneto ryšio."
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                children: "Kurso medžiaga"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                children: "Kiekvienam kurso dalyviui visa kurso medžiaga bus pateikta PDF formatu. Dokumente bus visa teorinė medžiaga bei kurso metu naudotas kodas."
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(info/* Companies */.OR, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                id: "features",
                                className: "my-background",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                        children: "Savybės"
                                    }),
                                    features.map((param)=>/*#__PURE__*/ {
                                        let [feature, desc, emoji] = param;
                                        return (0,jsx_runtime.jsxs)("div", {
                                            className: "grid grid-cols-12 grid-rows-3 items-center border-gray-900 p-1",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "col-span-3 text-center text-yellow-500 md:col-span-1",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "text-4xl ",
                                                        children: emoji
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "col-span-9 text-2xl md:col-span-11",
                                                    children: feature
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "col-span-12 row-span-2 ",
                                                    children: desc
                                                })
                                            ]
                                        }, feature);
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                id: "trainer",
                                className: "my-background",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                        children: "Dėstytojas"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                        children: "Aidis Stukas"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "md:flex-cols flex items-center gap-2",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "items-center gap-2 md:flex",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                    src: "/aidis.png",
                                                    height: 250,
                                                    width: 250,
                                                    alt: "Aidis Stukas"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                            children: [
                                                                "Programuoti pradėjau 2015 metais. Darbų patirtis: duomenų surinkimas (web-scraping), tinklalapių kūrimas su Django, front-end su React ir NextJS, Shopify aplikacijų kūrimas AdTech srityje, integracijų kūrimas su reklamos platformomis (pvz. Google Ads, Facebook Ads).",
                                                                " "
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            children: "Nuo 2018 metų dėsčiau programavimą su Python dviejose didžiausiose Lietuvos programavimo mokymus teikiančiose kompanijose. Vedžiau mokymus Python pažengusiųjų, Duomenų analitikos, Agile projektų valdymo kursus individualių asmenų grupėms ir kompanijoms."
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            children: "Tikiu, kad mano žingios ir įgūdžiai gali Jums padėti perprasti programavimą. Iki susitikimų!"
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                        children: [
                                            "Detaliau sužinoti galite mano LinkedIn profilyje",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                className: "inline",
                                                href: "https://lt.linkedin.com/in/aidis-stukas",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                    className: "m-10 inline",
                                                    width: 64,
                                                    height: 64,
                                                    src: "/linkedin.svg",
                                                    alt: "Aidis Stukas LinkedIn profile inline"
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                id: "discounts",
                                className: "my-background",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                        children: "Nuolaidų sistema"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    className: "",
                                                    children: "Apmokėjus 3 dienoms iki grupės pradžios taikome 10 % nuolaidą!"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    className: "",
                                                    children: "20 % nuolaida Jums jei į grupę atsivedate draugą."
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "text-sm text-gray-500",
                                        children: "* Nuolaidos nesumuojamos"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                id: "payment",
                                className: "my-background",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                        children: "Apmokėjimo galimybės"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            className: "",
                                            children: "Lankstus apmokėjimas, apmokėkite per 14 d. nuo kurso pabaigos."
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                id: "uzt",
                                className: "my-background",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                        children: "Studijų finansavimas per Užimtumo tarnybą"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: "Užimtumo tarnyba prie LR SADM skiria finansavimą nesimokančių, nedirbančių ir darbą pakeisti ketinančių asmenų mokymui. Finansavimas skiriamas formaliam, profesiniam mokymui, t.y. finansuojami ne trumpi kursai, bet ilgesnės studijos, leidžiančios įgyti kvalifikaciją."
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "flex justify-end",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: "/uzimtumo-tarnyba",
                                            className: "transition-border mx-10 rounded-md bg-mustard px-5 py-4 text-xl font-bold transition-colors duration-1000 dark:bg-green-500 dark:text-black sm:text-xl md:text-xl",
                                            children: "Daugiau"
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("aside", {
                        className: "lg:col-span-3",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "sticky top-14",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "my-background prose mt-0 max-w-none justify-items-center dark:prose-invert",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                        className: "",
                                        children: "Artimiausios Python pradedantiesiems grupės"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: " grid items-center justify-items-center sm:grid-cols-2 lg:grid-cols-1",
                                        children: courseInstances.sort(utils/* orderByOrder */.aV).map((i)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(CourseInstance, {
                                                instance: i,
                                                course: course
                                            }, i.startDate))
                                    })
                                ]
                            })
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var python_beginner = (Course);


/***/ }),

/***/ 4298:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(3573)


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [675,774,888,179], function() { return __webpack_exec__(1196); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);